import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import declare from "dojo/_base/declare";
import RecipeLineItemNumber from "./RecipeLineItemNumber";

const H2OAmountBeforeLoss = declare(RecipeLineItemNumber, {

	/**
	 * @override
	 * Render RecipeLineItem's H2OAmountBeforeLoss (C8-37886)
	 */
	toValue(ctx: Context, h: Heading) {
		const { QtyDefault, H2OAmountBeforeLoss } = ctx.getNode();
		const h2OContentPct = QtyDefault > 0.0 && H2OAmountBeforeLoss > 0.0 ? H2OAmountBeforeLoss / QtyDefault : 0.0;
		const value = h2OContentPct > 0.0 ? this.getAmount(ctx, false) * h2OContentPct : 0.0;
		return this.formatValue(value, this._getFormat(ctx, h));
	},

});

export = H2OAmountBeforeLoss;